export default {
  displayCalendar: 'calendar',
  displayCalendarWeek: 'calendarWeek',
  displayCalendarMonth: 'calendarMonth',
  displayList: 'list',
  purchaseRedirectTypeEmbedded: 'embedded',
  purchaseRedirectTypeUrl: 'url',
  purchaseRedirectTypeRouter: 'router'
}
